import { ApiResultVoListArticleListResponseVo } from '@schemas/non-auth'
import { createPrefetchQuery } from '@utils/createPrefetchQuery'
import { fetchAPI } from '@utils/http/apiRequest'
import { ArticleImportantReqModel, articleImportantQueryKey } from './types'

const path = '/restapi/v1/get/article/important'
export const fetchArticleImportant = async (
	arg?: ArticleImportantReqModel,
	cookieHeader?: string,
): Promise<ApiResultVoListArticleListResponseVo> => {
	const { isArticleArea, pageSize, articleListType } = arg ?? {}

	const params = new URLSearchParams({
		isArticleArea: String(isArticleArea),
		pageSize: String(pageSize ?? ''),
		...(articleListType ? { articleListType } : {}),
	})
	return fetchAPI({ path, params, cookieHeader })
}

export const initialArticleImportantReqArgs: ArticleImportantReqModel = {
	isArticleArea: true,
	pageSize: 5,
}

export const queryArticleImportant = (props: ArticleImportantReqModel, cookieHeader?: string) => ({
	queryKey: [articleImportantQueryKey, props],
	queryFn: () => fetchArticleImportant(props, cookieHeader),
})

export const prefetchArticleImportant = (props: ArticleImportantReqModel, cookieHeader?: string) =>
	createPrefetchQuery([articleImportantQueryKey, props], () =>
		fetchArticleImportant(props, cookieHeader),
	)
